/* eslint-disable no-shadow */

export enum ViewMode {
    Create = 'create',
    List = 'list',
    Update = 'update',
    Edit = 'edit', // alias for update
    Delete = 'delete',
    ViewItem = 'view-item',
    Detail = 'detail',
    Search = 'search',
    Custom = 'custom'
}

export enum ListMode {
    Grid = 'grid',
    Card = 'card'
}


export enum ItemActions {
    Edit = 'edit-item',
    Delete = 'delete-item',
    Create = 'create-item',
    ViewItem = 'view-item',
}

export enum ColumnOrder {
    OneColumn = 'one-column',
    TwoColumn = 'two-column',
    ThreeColumn = 'three-column'
}

export enum ColumnNumber {
    OneColumn = 1,
    TwoColumn = 2,
    ThreeColumn = 3
}
